<div class="card-expanded-host">
  <app-cards [card]="cardType" [controlsOptions]="controls"></app-cards>
  <button type="button" class="card-expanded-close" aria-label="Close" (click)="close()">
    <svg-icon src="assets/icons/icon-close.svg"></svg-icon>
  </button>
</div>
